import React, { useContext, useState, useEffect, useMemo, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { GridColumn } from "@progress/kendo-react-grid";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import { MoneyCell } from "../../../components/grid/Kendo/CustomKendoGridCells";
import {
  DefaultColumnWidth,
  DefaultDateColumnWidth,
  DefaultBooleanOrShortWidthColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";
export default function AdminExportBatchDetailModel(props) {
     const {
    batchId,
    user,
    contactType,
    getAccessToken
  } = props;
  const clientGridRef = useRef();
  const gridApiParams = useMemo(() => {
      if (IsNullOrEmpty(batchId)) {
        return {};
      }
  
      if (!batchId) {
        return {};
      }
  
      let params = {
         batchId: batchId,
         user: user,
      };
  
      return params;
    }, [batchId]);
  return (
     <Row>
          <Col md={12} className="tight-grid multi-line-filter">          
            <SharedMainSelectableClientGrid
              ref={clientGridRef}
              apiGetEndpoint={"api/RemittanceExport/GetBatchDetails"}
              apiParameters={gridApiParams}
              aggregateColumnSettings={null}
              //onDataRetrievedProcessor={getAllDetailData}
              exportFileNamePrefix={"AAdminExportBatchDetails"}
              
            >
                  <GridColumn
                             field="batchID"
                             title="Batch Id"
                             width={DefaultBooleanOrShortWidthColumnWidth()}
                           />
                           <GridColumn field="payer" title="Payer" width={DefaultColumnWidth()} />
                           <GridColumn
                             field="checkNumber"
                             title="Check Number"
                             width={DefaultColumnWidth()}
                           />
                           <GridColumn
                             field="checkDate"
                             title="Check Date"
                             filter={"date"}
                             format="{0:d}"
                             width={DefaultDateColumnWidth()}
                           />
                           <GridColumn
                             field="checkAmount"
                             title="Check Amount"
                             width={DefaultColumnWidth()}
                             cells={{ data: MoneyCell }}
                           />
                           <GridColumn
                             field="remitDate"
                             title="Remit Date"
                             filter={"date"}
                             format="{0:d}"
                             width={DefaultDateColumnWidth()}
                           />
                           <GridColumn
                             field="paymentDate"
                             title="Payment Date"
                             filter={"date"}
                             format="{0:d}"
                             width={DefaultDateColumnWidth()}
                           />
                           <GridColumn
                             field="archiveDate"
                             title="Archive Date"
                             filter={"date"}
                             format="{0:d}"
                             width={DefaultDateColumnWidth()}
                           />
                           <GridColumn field="ncpdp" title="NCPDP" width={DefaultColumnWidth()} />
                           <GridColumn
                             field="fileStatus"
                             title="Status"
                             width={DefaultColumnWidth()}
                           />
                           <GridColumn
                             field="fileName"
                             title="File Name"
                             width={DefaultColumnWidth()}
                           />
                </SharedMainSelectableClientGrid>
          </Col>    
        </Row>
  );
}